import React from 'react';
import * as S from './Label.style';
export const Label = ({ value, ...rest }) => (React.createElement(S.Label, Object.assign({}, rest), value));
//# sourceMappingURL=Label.js.map